module.exports = __webpack_public_path__ + "img/calendar-7.3a7c7d9a.svg";